import { Component, ViewChild, ElementRef , HostListener, Inject } from '@angular/core';
import { projectConstants } from '../../../shared/constants/project-constants';
import { MatPaginator } from '@angular/material/paginator';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
@Component({
  selector: 'app-item-view',
  templateUrl: './item-view.component.html',
  styleUrls: ['./item-view.component.css']
})
export class ItemViewComponent {
  tableFilters = '';
  displayedColumns = ['loginId','createdDate' , 'otpPurpose', 'sharedkey', 'sessionId','firstName'];
  @ViewChild(MatPaginator, {static: false}) paginator: MatPaginator;
  @ViewChild('go', {static: false}) go: ElementRef;
  showToolBar = false;
  screenHeight;
  screenWidth;
  salesChannelss;
  paymentDetais;
  showsaleschannel;
  small_device_display = false;
  salesfilter;
  orderItem: any = [];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any) {
    }

  ngOnInit() {
    this.orderItem = this.data
    
  }
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.screenHeight = window.innerHeight;
    this.screenWidth = window.innerWidth;
    if (this.screenWidth <= projectConstants.SMALL_DEVICE_BOUNDARY) {
      this.small_device_display = true;
    } else {
      this.small_device_display = false;
    }
  }
}
